























import { defineComponent, ref } from '@nuxtjs/composition-api';
import { SfTopBar } from '@storefront-ui/vue';
import { useTopBar } from './useTopBar';
import type { ProductInterface } from '~/modules/GraphQL/types';
import RelatedSite from '~/components/General/RelatedSite.vue';

export default defineComponent({
  components: {
    CurrencySelector: () => import('../CurrencySelector.vue'),
    StoreSwitcher: () => import('../StoreSwitcher.vue'),
    SfTopBar,
    SearchBar: () => import('~/components/Header/SearchBar/SearchBar.vue'),
    RelatedSite,
  },
  setup() {
    const { hasCurrencyToSelect, hasStoresToSelect } = useTopBar();
    const isSearchOpen = ref(true);
    const productSearchResults = ref<ProductInterface[] | null>(null);

    return {
      hasCurrencyToSelect,
      hasStoresToSelect,
      isSearchOpen,
      productSearchResults,
      
    };
  },
});

